module.exports = __webpack_public_path__ + "img/gracias.ba32d8f6.png";